import { FormControlLabel, MenuItem, Select } from "@mui/material";
import SearchComponent from "components/SearchComponent";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { getOneOffOrders } from "models/subscriptionsModel";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { openLoading } from "store/reducers/tools";
import OneOffOrdersTable from "./OneOffOrdersTable";

const options = [
  { label: "All", tab: "all" },
  { label: "Active", tab: "1" },
  { label: "Cancel", tab: "0" },
];

const perPage = 50;

export default function OneOffOrdersComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [searchWord, setSearchWord] = useState("");
  const [searchType, setSearchType] = useState("all");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [totalPage, setTotalPage] = useState(1);
  const [filter, setFilter] = useState({});

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  const handleChangePage = (v) => {
    setFilter((prev) => ({ ...(prev ?? {}), ...(v ?? {}) }));
  };

  const loadData = () => {
    openLoading(true);
    getOneOffOrders({
      data: {
        limit: perPage,
        ...filter,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res?.data ?? []);
        setTotalPage(res?.pageCount ?? 1);
      },
    });
  };

  useEffect(() => {
    if (
      searchWord ||
      searchType ||
      startDate ||
      endDate ||
      activeTab !== "all"
    ) {
      let filter = {
        [searchType]: searchWord,
        startDate,
        endDate,
        status: activeTab,
      };

      setFilter((prev) => ({
        sortKey: prev?.sortKey ?? {},
        page: 1,
        ...(filter ?? {}),
      }));
    }
    // eslint-disable-next-line
  }, [searchWord, searchType, activeTab, startDate, endDate]);

  useEffect(() => {
    if (filter?.sortKey) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div>
      <div className="flex justify-between mb-4">
        <div className="flex">
          <SearchComponent
            searchWord={searchWord}
            searchType={searchType}
            placeholder="Search One-Off Orders"
            onChange={(e) => {
              setSearchType(e.target.value);
            }}
            onChangeSearchWord={handleSearchWord}
            onKeyDown={(e) => handleSearchWord(e)}
            onBlur={handleSearchWord}
          />
          <FormControlLabel
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Status :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
              >
                {options?.map((item) => (
                  <MenuItem value={item?.tab} key={item?.tab}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        </div>
        <FormControlLabel
          className="z-10"
          sx={{ marginRight: 0 }}
          label={
            <CustomText
              className="whitespace-nowrap"
              variant="body2"
              color="secondary"
              bold={true}
            >
              Date :&nbsp;
            </CustomText>
          }
          labelPlacement="start"
          control={
            <DatePicker
              className="px-2 py-1 border rounded border-white-gray"
              selectsRange={true}
              startDate={startDate}
              dateFormat={"dd MMM"}
              endDate={endDate}
              onChange={(update) => {
                setDateRange(update);
              }}
              isClearable={true}
            />
          }
        />
      </div>
      <OneOffOrdersTable
        data={data ?? []}
        onLoadData={handleChangePage}
        totalPage={totalPage}
        page={filter?.page}
      />
    </div>
  );
}
